interface IfProps {
  condition: any
}

export const If = ({ condition, children }: React.PropsWithChildren<IfProps>) => {
  if (condition) return <>{children}</>
  return null
}
